import { Icon } from "@chakra-ui/react"
import * as icons from "@pathwright/pathicons"
import PropTypes from "prop-types"
import React from "react"

const Pathicon = React.forwardRef(({ name, ...props }, ref) => {
  const componentName = componentNameFromIconName(name)
  const IconComponent = icons[componentName]
  if (!IconComponent) {
    console.warn(`Icon ${name} (${componentName}) not found`)
    return <Icon ref={ref} />
  }

  const boxSize = props.size ? `${props.size}px` : props.boxSize || undefined

  return (
    <Icon
      ref={ref}
      boxSize={boxSize}
      as={IconComponent}
      alt={name}
      {...props}
    />
  )
})

export const iconNameFromComponentName = componentName => {
  let name = componentName.replace("Icon", "")
  // split by capital letters
  const split = name.split(/(?=[A-Z])/)
  // join with hyphen
  name = split.join("-").toLowerCase()
  return name
}

export const componentNameFromIconName = iconName => {
  // split by hyphen
  const split = iconName.split("-")
  // capitalize each element
  const capitalized = split.map(
    word => word.charAt(0).toUpperCase() + word.slice(1)
  )
  // join with capital letters
  return `${capitalized.join("")}Icon`
}

export const iconNames = Object.keys(icons)
  // Hmm, filter out exports that are not icons...
  .filter(
    icon =>
      !["componentNameFromIconName", "iconNameFromComponentName"].includes(icon)
  )
  .map(name => iconNameFromComponentName(name))

Pathicon.defaultProps = {
  size: 24,
  fill: "currentColor"
}

Pathicon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.oneOf([...iconNames])
}

export default Pathicon
